import GamesConfig from "./GamesConfig"
import Constant from "../Shared/Constant";
import GameList from "../Models/GameList";
import { Global } from "../Shared/Global";
import EllipticalStage from "../Common/EllipticalStage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class ElectronicLayer extends cc.Component {
    @property(EllipticalStage)
    ellipticalStage: EllipticalStage = null
    
    @property(cc.Widget)
    wgtStage: cc.Widget = null

    @property(cc.Node)
    nodeBgSpine: cc.Node = null

    private _selectedNode: cc.Node = null

    onLoad () {
        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtStage.left += Constant.BangLength
            this.ellipticalStage.maxShowCount = 8
        }

        this.nodeBgSpine.scaleX = cc.winSize.width / cc.view.getDesignResolutionSize().width
        cc.director.on(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    onEnable () {
        // 大佬要求不滑动
        // this.ellipticalStage.rotateStageInTime(Math.PI / 2, 0.3)
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.GameListChanged, this.createNodeItems, this)
    }

    onRotateStageEvents (ellipticalStage, eventType: Global.EllipticalStageEventType) {
        if (eventType === Global.EllipticalStageEventType.ROTATE_BEGAN) {
            this.selectedNode(null)
        }else if (eventType === Global.EllipticalStageEventType.ROTATE_ENDED) {
            this.checkSelectedNode()
        }
    }

    private createNodeItems () {
        if (!GameList.serverData) {
            return
        }
        
        let gameCfgs = GameList.getGameListByType(Global.GameType.Electronic)
        let items = gameCfgs["twoLevelList"] ? gameCfgs["twoLevelList"].slice() : []  
        let loadCount = 0

        // 最少个数
        if (items.length > 0) {
            let needNum = this.ellipticalStage.maxShowCount - items.length
            while (needNum > 0) {
                for (let i = 0; i < Math.min(items.length, needNum); i++) {
                    items.push(JSON.parse(JSON.stringify(items[i])))
                }
                needNum = this.ellipticalStage.maxShowCount - items.length
            }
        }
        
        items.forEach(item => {
            let node = new cc.Node()
            let nodeSpine = new cc.Node()
            let skeleton = nodeSpine.addComponent(sp.Skeleton)
            let button = node.addComponent(cc.Button)
            let res = GamesConfig.electronic[item.gameTitleCn]
        
            nodeSpine.name = "nodeSpine"
            nodeSpine.scale = 1.1
            nodeSpine.parent = node
            node.anchorY = 0
            node.width =  300
            node.height =  370
            nodeSpine.y = node.height * 0.45
            node.parent = this.ellipticalStage.node

            if (!res) {
                res = "Hall/Electronic/dianzi_01"

                if (Constant.RemindMissingRes) {
                    let nodeLabel = new cc.Node()
                    let lbLack = nodeLabel.addComponent(cc.Label)
                    
                    nodeLabel.color = cc.color(255, 0, 0)
                    nodeLabel.parent = node
                    lbLack.string = item.gameTitleCn + "\n缺少美术资源！"
                    lbLack.fontSize = 40
                }
            }
            
            cc.loader.loadRes(res, sp.SkeletonData, function (err, skeletonData) {
                if (!err && this.node) {
                    skeleton.skeletonData = skeletonData
                    skeleton.animation = "an_00"
                }

                loadCount++

                if (loadCount === items.length) {
                    this.checkSelectedNode()
                }
            }.bind(this))

            // 特殊处理热门图标
            if (["AG电子", "PG电子", "MG电子"].indexOf(item.gameTitleCn) !== -1) {
                let nodeHot = new cc.Node()
                let spHot = nodeHot.addComponent(cc.Sprite)

                nodeHot.setAnchorPoint(cc.v2(1, 1))
                nodeHot.position = cc.v2(node.width * 0.32, node.height * 0.52)
                nodeHot.scale = 0.6
                nodeHot.parent = nodeSpine

                cc.loader.loadRes("Common/hot", cc.SpriteFrame, function (err, spriteFrame) {
                    if (!err && spHot && spHot.isValid) {
                        spHot.spriteFrame = spriteFrame
                    }
                }.bind(this))
            }

            // 游戏维护
            if (item.gameStatus === "2") {
                let nodeMaintenance = new cc.Node()
                let spMaintenance = nodeMaintenance.addComponent(cc.Sprite)
                
                nodeMaintenance.parent = nodeSpine
                nodeSpine.color = cc.color(70, 70, 70)

                cc.loader.loadRes("Common/maintenance", cc.SpriteFrame, function (err, spriteFrame) {
                    if (!err && spMaintenance && spMaintenance.isValid) {
                        spMaintenance.spriteFrame = spriteFrame
                    }
                }.bind(this))
            }

            let clickEventHandler = new cc.Component.EventHandler()
            clickEventHandler.target = cc.find("Canvas/gameNode")
            clickEventHandler.component = "HallUI"
            clickEventHandler.handler = "onGameItemClick"
            button.clickEvents.push(clickEventHandler)
            button.node["gameConfig"] = item
        });
    }

    private selectedNode (node: cc.Node) {
        if (this._selectedNode === node) {
            return
        }

        if (this._selectedNode) {
            this._selectedNode.getChildByName("nodeSpine").getComponent(sp.Skeleton).animation = "an_00"
            this._selectedNode.getChildByName("nodeSpine").y += 20
        }

        this._selectedNode = node

        if (this._selectedNode) {
            this._selectedNode.getChildByName("nodeSpine").getComponent(sp.Skeleton).animation = "liang_00"
            this._selectedNode.getChildByName("nodeSpine").y -= 20
        }
    }

    private checkSelectedNode () {
        let curNode = null

        this.ellipticalStage.node.children.forEach(node => {
            if (node.opacity === 255 && (!curNode || Math.abs(node.x) < Math.abs(curNode.x))) {
                curNode = node
            }
        });

        if (curNode) {
            this.selectedNode(curNode)
        }
    }
}
